import React from "react";
import { styled } from "styled-components";
import BrowseArtistFilter from "../browseArtistFilter/BrowseArtistFilter";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone_solid.svg";

const Container = styled.div`
    background-color: #252424;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 56px;
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 1px solid #ffffff;
    width: 100%;
    padding-top: 12px;
    padding-bottom: 12px;
    z-index: 999;
    @media (min-width: 1024px) {
        display: none;
    }
`;

const Telephone = styled.a`
    color: #fff;
    font-size: 20px;
    text-decoration: none;
`;

const MobileActionBar = ({ apiEndpoint, dateBaseURL, filter_url, api_endpoint }) => {
    return (
        <Container>
            <div>
                <BrowseArtistFilter
                    filter_url={filter_url}
                    api_endpoint={api_endpoint}
                />
            </div>
            <div>
                <Telephone href="tel:+61390072069">
                    <PhoneIcon height="20px"
                        width="20px" />
                </Telephone>
            </div>
        </Container>
    );
};

export default MobileActionBar;
